import type {
  ForgotPasswordRequest,
  LoginRequest,
  MessageResponse,
  PasswordBrokerStatusResponse,
  RegisterRequest,
  ResetPasswordRequest,
  SuccessResponse,
} from '@/js/account/shared/model';
import { accountHttp } from '@/js/account/shared/api';

export async function accountLogin(
  payload: LoginRequest,
): Promise<SuccessResponse> {
  const { data } = await accountHttp.post<SuccessResponse>('/login', payload);
  return data;
}

export async function accountRegister(
  payload: RegisterRequest,
): Promise<SuccessResponse> {
  const { data } = await accountHttp.post<SuccessResponse>(
    '/register',
    payload,
  );
  return data;
}

export async function accountLogout(): Promise<SuccessResponse> {
  const { data } = await accountHttp.post<SuccessResponse>('/logout');
  return data;
}

export async function accountForgotPassword(
  payload: ForgotPasswordRequest,
): Promise<PasswordBrokerStatusResponse> {
  const { data } = await accountHttp.post<PasswordBrokerStatusResponse>(
    '/forgot-password',
    payload,
  );
  return data;
}

export async function accountResetPassword(
  payload: ResetPasswordRequest,
): Promise<PasswordBrokerStatusResponse> {
  const { data } = await accountHttp.post<PasswordBrokerStatusResponse>(
    '/reset-password',
    payload,
  );
  return data;
}

export async function accountEmailVerificationResend(): Promise<
  SuccessResponse | MessageResponse
> {
  const { data } = await accountHttp.post<
    SuccessResponse | MessageResponse
  >('/email/verification-notification');
  return data;
}
